import React from 'react';

interface CurrencySectionProps {
  defaultCurrency: string;
  setDefaultCurrency: (val: string) => void;
}

const CurrencySection: React.FC<CurrencySectionProps> = ({
  defaultCurrency,
  setDefaultCurrency,
}) => {
  const currencies = ['USD', 'EUR', 'JPY', 'GBP', 'AUD', 'CAD', 'CHF', 'CNY', 'KRW', 'BTC', 'ZAR'];

  return (
    <div>
      <label htmlFor="defaultCurrency" className="block text-sm font-medium text-white">
        Default Currency
      </label>
      <select
        id="defaultCurrency"
        name="defaultCurrency"
        value={defaultCurrency}
        onChange={(e) => setDefaultCurrency(e.target.value)}
        className="mt-1 block w-full rounded-md bg-black text-white border border-gray-600 p-3 focus:ring focus:outline-none"
        required
      >
        {currencies.map((currency) => (
          <option key={currency} value={currency}>
            {currency}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySection;

